import moment from 'moment';
import { Layout } from "antd";
import defaultStyle from './Layout.module.scss';
import styleSM from './Layout.module.scss'
import PopoverForm from '../Components/PopoverForm/PopoverForm';

const stylesMap: any = {
  SN: styleSM,
  // Agrega más si es necesarios
};
let styles = stylesMap[process.env.REACT_APP_CODE_TENANT as string] || defaultStyle;
const LayoutComponent = (props: any) => {
  const { Header, Footer, Content } = Layout;
  const actualDate = new Date();
  return (
    <div className={process.env.REACT_APP_CODE_TENANT == "MT" ? styles["layout-container-mt"]:styles["layout-container"]}>
     
      <Layout >        
        {/* <Header>
          dfsdf
        </Header> */}
        <Content>
          {props.children}
        </Content>
        {/* <Footer>
          <div className={styles["footer-text"]}>
            <p>Todos los derechos reservados {moment(actualDate).format("YYYY")}. Desarrollado por BluelightCoding</p>
          </div>
        </Footer> */}
      </Layout>
    </div>
  );
}


export default LayoutComponent;